/**
 * Typed access to the SPA's runtime env. All Vite-injected env vars are
 * `string | undefined` — wrapping them here keeps every consumer honest about
 * which ones are required vs optional.
 */
const env = import.meta.env;

export const ENV = {
  apiUrl: requireEnv('VITE_API_URL'),
  webUrl: requireEnv('VITE_WEB_URL'),

  googleClientId: env.VITE_GOOGLE_CLIENT_ID ?? '',

  sentryDsn: env.VITE_SENTRY_DSN ?? '',
  posthogApiKey: env.VITE_POSTHOG_API_KEY ?? '',
  posthogHost: env.VITE_POSTHOG_HOST ?? 'https://us.posthog.com',

  paddleClientToken: env.VITE_PADDLE_CLIENT_TOKEN ?? '',
  paddleEnv: (env.VITE_PADDLE_ENV ?? 'sandbox') as 'sandbox' | 'production',
  paddlePriceMonthly: env.VITE_PADDLE_PRICE_MONTHLY ?? '',
  paddlePriceAnnual: env.VITE_PADDLE_PRICE_ANNUAL ?? '',

  mode: env.MODE,
  isDev: env.DEV,
  isProd: env.PROD,

  // Vercel injects these at build time when deploying from a GitHub repo.
  // Used only for Sentry release tagging and disabling Sentry on previews.
  vercelEnv: (env.VERCEL_ENV ?? '') as '' | 'production' | 'preview' | 'development',
  release: env.VERCEL_GIT_COMMIT_SHA ?? 'local',
} as const;

function requireEnv(key: string): string {
  const value = env[key];
  if (!value) {
    if (env.PROD) {
      // Fail loudly in production; a missing API URL means every request 404s.
      throw new Error(`Missing required env var: ${key}`);
    }
    // Dev: warn but don't crash — `pnpm dev` should still boot for local work.
    console.warn(`[bazi/web] Missing env var ${key}; using empty string`);
  }
  return value ?? '';
}
